import { render, staticRenderFns } from "./InstallAppLink.vue?vue&type=template&id=7dbe1b4b"
import script from "./InstallAppLink.vue?vue&type=script&lang=js"
export * from "./InstallAppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports